module.exports = __webpack_public_path__ + "static/MarjieBohning-3bc819c0e5d2d1c2c07708ad24f2f09a.png";